import React from 'react';

import {
	SnackbarProvider,
	SnackbarProviderProps,
	useSnackbar
} from 'notistack';

import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';

function SnackbarCloseButton({
	snackbarKey
}: {
	snackbarKey: string | number;
}) {
	const { closeSnackbar } = useSnackbar();

	return (
		<Box>
			<IconButton
				onClick={() => closeSnackbar(snackbarKey)}
				sx={{ width: 20, height: 20 }}>
				<CloseIcon sx={{ color: '#fff', width: 16, height: 16 }} />
			</IconButton>
		</Box>
	);
}

const Snackbar = (props: SnackbarProviderProps) => {
	const { children, ...rest } = props;
	return (
		<SnackbarProvider
			action={(snackbarKey) => (
				<SnackbarCloseButton snackbarKey={snackbarKey} />
			)}
			style={{ flexWrap: 'unset' }}
			// iconVariant={}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
			{...rest}>
			{children}
		</SnackbarProvider>
	);
};

export { Snackbar };
export default Snackbar;
